<template>
  <div class="life-cover" :style="{backgroundImage: modifiedBackground }"></div>
</template>

<script>
export default {
  props: ['backgroundUrl'],
  computed: {
    modifiedBackground: function () {
      return `url('/${process.env.STATIC_PATH}/${this.backgroundUrl}')`
    }
  }
}
</script>

<style scoped>
  .life-cover {
    background-position: center top;
    background-size: cover;
    padding: 60px 0;
    position: relative;
    margin-bottom: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Life_SubHeader.vue